import React, { useRef } from "react";
import { cloneElement } from 'react';
import { isMobile, useMobileOrientation } from 'react-device-detect';
import useDetectKeyboardOpen from "use-detect-keyboard-open";
// import {  styled } from '@mui/material/styles';

import {
  Box,
  Typography,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Divider,

} from '@material-ui/core';

import {
  DateField,
  List,
  required,
  FormDataConsumer,
  Show,
  Toolbar,
  Edit,
  SimpleForm,
  ReferenceField,
  SimpleShowLayout,
  TextField,
  ReferenceInput,
  TextInput,

  Datagrid,
  // SimpleFormIterator,
  // ArrayInput,

  TopToolbar,
  useCreate, useNotify, ArrayField,

  FileField,
  useRedirect,
  CreateButton,
  SaveButton,
  SelectInput,
  usePermissions,
  Filter,
  ChipField,
  ImageField,
  FileInput,
  RecordContextProvider,
  BooleanInput,
  SearchInput,
  useShowContext,
  ReferenceArrayInput,
  AutocompleteArrayInput,
} from "react-admin";
import { IdateTimeInput } from '../../data/IdateTimeInput';

// import { useDownloadExcel } from 'react-export-table-to-excel';
import ReactHTMLTableToExcel from "react-html-table-to-excel";


import { ROLES } from '../../constants';

import CreateView from "../../components/CreateView";
// import ShowView from "../../components/ShowView";

// import { makeStyles } from "@material-ui/core/styles";

import { Plugins } from 'rc-tween-one';


import SvgMorphPlugin from 'rc-tween-one/es/plugin/SvgMorphPlugin';
import CustomProductList from "./productList";
Plugins.push(SvgMorphPlugin);




const LoadingRequestFilter = (props) => {
  const { permissions } = usePermissions();

  return (
    <Filter {...props} >

      {/* <ReferenceInput variant="outlined" label="از واحد " source="user.unitId" reference="unit" >
      <SelectInput optionText="title" />
    </ReferenceInput> */}
      {(permissions?.includes(ROLES.SUPER_ADMIN) ||
        permissions?.includes(ROLES.USERS_ADMIN) ||
        permissions?.includes(ROLES.ANBAAR_ADMIN) ||
        permissions?.includes(ROLES.SALE_ADMIN)) && <ReferenceInput variant="outlined" label=" پردازنده" source="unitId" reference="unit" >
          <SelectInput optionText="title" />
        </ReferenceInput>}
      {(permissions?.includes(ROLES.SUPER_ADMIN) ||
        permissions?.includes(ROLES.USERS_ADMIN) ||
        permissions?.includes(ROLES.ANBAAR_ADMIN) ||
        permissions?.includes(ROLES.SALE_ADMIN)) && <ReferenceInput alwaysOn variant="outlined" label=" از واحد" source="[user.unitId]" reference="unit" >
          <SelectInput optionText="title" />
        </ReferenceInput>}

      <ReferenceInput variant="outlined" label="وضعیت" source='statusLoadingId' reference="statusLoading" >
        <SelectInput optionText="title" />
      </ReferenceInput>

      {(!permissions?.includes(ROLES.USER_EXPERIMENTAL)) && <BooleanInput optionText="isArchived" alwaysOn label="پایان سفارش بیشتر از دو روز" source="isArchived" />}
      <SearchInput variant="outlined" resettable source="q" alwaysOn />

      {/* <MaterialDateTimeInput
        source="start"
        label="از"
        options={{ format: 'DD/MM/YYYY', label: "از" }}
        alwaysOn
      >salam</MaterialDateTimeInput>
      <MaterialDateTimeInput
        source="end"
        label="تا"
        options={{ format: 'DD/MM/YYYY', label: "تا" }}
        alwaysOn
      /> */}


    </Filter>
  )
};


const CreateTemplateButton = ({ record }) => {
  const notify = useNotify();
  const redirect = useRedirect();
  const [create, { isLoading }] = useCreate(
    'loadingRequest',
    { isTemplate: true },
    {
      onSuccess: (data) => {
        console.log(data)
        redirect('edit', 'loadingRequest', data.data.id);

      },
      onError: (error) => {
        // failure side effects go here 
        notify(`خطا در ایجاد   : ${error.message}`, { type: 'warning' });
      },
    }
  );

  return <CreateButton label="ایجاد  " onClick={(e) => { e.preventDefault(); e.stopPropagation(); create() }} disabled={isLoading} />;
};

const ListActions = (props) => {

  return (
    <TopToolbar>
      {/* <CreateButton onClick={(e) => {e.preventDefault();e.stopPropagation();
       handleClick(); 
  }}
    /> */}
      {cloneElement(props.filters, { context: 'button' })}
      <CreateTemplateButton />

    </TopToolbar>
  )
};

const postRowClick = (id, resource, record) => record.isArchived ? 'show' : 'edit';


export const LoadingRequestList = (props) => {

  return (

    <List {...props} actions={<ListActions />}
      filters={<LoadingRequestFilter />}
      sort={{ field: 'createdAt', order: 'DESC' }} >
      {window.screen.width < 1280 ? (
        <Datagrid rowClick={postRowClick} >
          <ReferenceField link={null} label="از واحد " source="user.unitId" reference="unit" >
            <TextField source="title" />
          </ReferenceField>
          <TextField source="refNum" label="کد پیگیری " />
          <ReferenceField link={null} label="وضعیت  " source='statusLoadingId' validate={required()} reference="statusLoading" >
            <ColoredChipField source="title" select="id" />
          </ReferenceField>

        </Datagrid>

      ) : (
        <Datagrid rowClick={postRowClick} >
          <ReferenceField link={null} label="از واحد " source="user.unitId" reference="unit" >
            <TextField source="title" />
          </ReferenceField>

          <ReferenceField link={null} label="زیر واحد " source="unitId" reference="unit" >
            <TextField source="title" />
          </ReferenceField>

          {/* <ReferenceField link={null} label="زیر واحد " source="unitProcessorId" reference="unitProcessor" >
        <TextField source="title" />
      </ReferenceField> */}
          <TextField source="refNum" label="کد پیگیری " />
          <ReferenceField link={null} label="وضعیت  " source='statusLoadingId' validate={required()} reference="statusLoading" >
            <ColoredChipField source="title" select="id" />
          </ReferenceField>
          <TextField source="descript" rows={2} label="توضیحات" />

          <TextField source="user.name" label="ایجاد کننده " />
          {/* <TextField source="objectId"/> */}
          <DateField options={{ weekday: 'long', year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }} locales="fa-IR" source="createdAt" label="  تاریخ ایجاد " />
          <DateField options={{ weekday: 'long', year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }} locales="fa-IR" source="dueDate" label="  تاریخ تحویل " />

        </Datagrid>
      )}
    </List>
  )
};


// const useStyles = makeStyles(() => ({
//   root: {
//     float: 'right',

//     // position:'absolute'

//   },
//   form: {
//     width: '80%',
//     display: 'flex',
//     flexDirection: 'row',
//     alignItems: 'center',
//     float: 'right',

//   },
//   line: {
//     marginRight: '1%',
//     height: '50px',

//     border: 0,
//   },
// }));

const Aside = (props) => {
  const { isLandscape } = useMobileOrientation()
  const isKeyboardOpen = useDetectKeyboardOpen();
  return (
    <div style={{ margin: '1em', overflow: 'auto',width: "100%" , minWidth:"250px",maxWidth:"350px", height: "700px", borderTopWidth: "3px", borderBottomWidth: "3px" }}>

      {!isMobile || (isLandscape && !isKeyboardOpen) ? (


        <Box sx={{ width: '100%' }}>
          <Typography variant="h6">تاریخچه</Typography>

          <Stepper orientation="vertical" sx={{ mt: 1 }}>
            {


              (props.record && props.record.history) ? props.record.history.map((his, i) => (


                <Step expanded active completed >
                  <StepLabel>
                    {/* <Typography variant="h8">{his.customerNumber}</Typography> */}

                    <ReferenceField link={null} label="وضعیت  " source={`history[${i}].statusLoadingId`} validate={required()} reference="statusLoading" >
                      <ColoredChipField source="title" />

                    </ReferenceField>

                    <p>پردازنده : <ReferenceField link={null} label="زیر واحد " source={`history[${i}].unitProcessorId`} validate={required()} reference="unitProcessor" >
                      <TextField source="title" />
                    </ReferenceField></p>
                    {/* <Typography variant="h5">عدم موجودی</Typography> */}
                    <div>

                      {new Date(his.updatedAt).toLocaleString("fa", { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', })}
                    </div>
                    <div>
                      تغییر توسط :
                      {his.lastEditBy}
                    </div>
                    {(his.description) ? (
                      <div>

                        <div>
                          کامنت  :

                        </div>
                        <div><p style={{ "white-space": "pre-wrap", "overflow-wrap": "break-word", "inline-size": "250px" }}>{his.description}</p></div>
                      </div>

                    ) : null}
                    <Divider></Divider>

                  </StepLabel>
                  <StepContent>
                    <RecordContextProvider value="تغییر داده شده">
                    </RecordContextProvider>
                  </StepContent>
                </Step>
              )) : null
            }
          </Stepper>
        </Box>
      ) : (
        <Box></Box>
      )}
    </div>
  )
}
const PostEditToolbar = props => {
  return (
    <Toolbar {...props} >
      <SaveButton redirect="list" />
      {/* <ScrollContainer>
          <div style={{ display: "flex", justifyContent: "left", alignItems: "center", height: "100%" }} >
            <Animator animation={MoveOut(-1000, 0)}> */}

      {/* </Animator>
          </div>

      </ScrollContainer> */}
      {/* <SaveButton redirect="list" style={{ position: "fixed", top: "8px", left: "8px", zIndex: 3211 }} /> */}
      {/* 
    <Tween
          animation={[
            { rotateY: 10 , duration: 2000,repeat:2 , delay:5000,repeatDelay:5000 },
          ]}
          style={{
            position: "fixed", top: "60px", left: "20px",
            marginLeft: 20, width: 100,
            transform: 'perspective(200px) rotateY(10deg)',
          }}
        >
          <div><SaveButton redirect="list" style={{ zIndex: 3211}}/> </div>
        </Tween> */}
      <SaveButton redirect="list"
        style={{
          position: "fixed", top: "60px", left: "20px",
          marginLeft: 20, width: 100,
          zIndex: 3211
        }}
        />
    </Toolbar>
  )
};


export const LoadingRequestEdit = (props) => {

  // const classes = useStyles();
  // const { permissions } = usePermissions();
  const { isLoading } = useShowContext();

  if (isLoading) return null;


  return (
    <Edit mutationMode="pessimistic" {...props} undoable={false} aside={<Aside />} >



      <SimpleForm submitOnEnter={false} variant="outlined" toolbar={<PostEditToolbar />}>

        <ReferenceInput label="واحد گیرنده " source="unitId" validate={required()} reference="unit" >
          <SelectInput optionText="title" style={{ display: 'inline-grid', float: 'right', marginLeft: '10px' }} />
        </ReferenceInput>
        <FormDataConsumer>
          {({ formData, ...rest }) => (
            <ReferenceInput filter={{ unitId: (formData.unitId === undefined) ? "alaki" : formData.unitId }} label=" پردازنده " source="unitProcessorId" validate={required()} reference="unitProcessor" >
              <SelectInput optionText="title"   {...rest} />
            </ReferenceInput>
          )}
        </FormDataConsumer>
        <ReferenceInput label="وضعیت " source="statusLoadingId" reference="statusLoading" >
          <SelectInput optionText="title" allowEmpty />
        </ReferenceInput>
        <ReferenceArrayInput variant="outlined" source="usersInvolved" label="همکاران" reference="adminUsers">
          {/* <SelectInput optionText="title" style={{ float: 'right', marginLeft: '10px', width: '70%' }} /> */}
          <AutocompleteArrayInput source="name" optionText="name" />
        </ReferenceArrayInput >

        <TextInput source="descript" style={{ width: "60%" }} multiline label="توضیحات" rows={4} fullWidthlabel="توضیحات" />
        <TextInput source="description_comment" label=" کامنت" multiline rows={3} />
        <ReferenceField link={null} label="از واحد " source="user.unitId" reference="unit" >
          <TextField source="title" />
        </ReferenceField>

        <TextInput source="deliveryLocation" label=" محل تحویل" />
        {/* <div>زمان تحویل</div>
      <MaterialDateTimeInput
        inputVariant="outlined"

        source="dueDate"
        label={
          <FieldTitle
            label="تاریخ تحویل"
          />
        }
        options={{ format: 'DD/MM/YYYY' }}
      /> */}
        <IdateTimeInput source='dueDate' label="تاریخ تحویل" />
        <br />
        <br />
        <br />
        <div style={{ display: 'flex', flexDirection: 'row', marginRight: '24px' }}>
          {/* <pre style={{ position: 'absolute', width: 400, marginRight: 16, right: 350, }}>کالا</pre>
        */}
          {/* <b style={{ width: 100, }} >موجودی</b>
          <b style={{ width: 100, }} > درخواست</b> */}
          {/* <b > ارسالی</b> */}

        </div>
        {/* <ArrayInput source="products" label=""
          isEnabled={({ q }) => {
            return !!q && q.length > 2
          }}
        >

          <SimpleFormIterator
            className="grid grid-flow-row-dense mx:grid-cols-1 md:grid-cols-3 grid-rows-3  border-spacing-6 border-cyan-400"
            TransitionProps={{ enter: false, exit: false }} variant="outlined" disableRemove disableAdd disableReordering>

            <FormDataConsumer>
              {({ formData, getSource, scopedFormData, ...rest }) => (
                <>

                  <div>
                    <ImageField {...rest} source="productId.icon" className="align-middle" />
                    <TextField {...rest} source="productId.title" />
                  </div>
                  <div classes={classes}>
                    <TextInput source={getSource("supply")} variant="outlined" locales={"fa"} style={{ position: 'relative', width: 90, marginTop: "15px", marginLeft: "8px" }} label="موجودی" disabled />
                    <TextInput source={getSource("need")}
                      onWheel={e => e.target instanceof HTMLElement && e.target.blur()}
                      label="درخواست"
                      disabled={(formData.isFirst) ? false : true} variant="outlined" locales={"fa"} style={{ position: 'relative', width: 90, marginTop: "15px", marginLeft: "8px" }} defaultValue={0} />
                    <RedNumberInput id="custom-css-outlined-input"
                      source={getSource("accepted_supply")}
                      onWheel={e => e.target instanceof HTMLElement && e.target.blur()}
                      label="ارسالی"
                      variant="outlined"
                      color="red"
                      disabled={((!formData.isFirst) &&
                        (
                          // permissions?.includes(ROLES.SUPER_ADMIN) ||
                          // permissions?.includes(ROLES.ANBAAR_ADMIN) ||
                          // permissions?.includes(ROLES.USERS_ADMIN) ||
                          // permissions?.includes(ROLES.UNIT_ADMIN)
                          //Object.keys(ROLES)
                          [ROLES.SUPER_ADMIN, ROLES.ANBAAR_ADMIN, ROLES.USERS_ADMIN, ROLES.UNIT_ADMIN]
                            .some(pr => permissions?.includes(pr))
                        ))

                        ? false : true}
                      locales={"fa"} sx={{}} style={{ floodColor: "red", boxShadow: 3, position: 'relative', width: 90, marginTop: "15px" }} />
                  </div>
                </>
              )}
            </FormDataConsumer>


          </SimpleFormIterator>
        </ArrayInput> */}
        <CustomProductList/>
        <FileInput source="attachfile" label="سند مربوطه" >
          <ImageField source="src" title="title" />
        </FileInput>
        <FileField label="فایل های ضمیمه" source="attachments" src="url" title="دریافت" target="_blank" />
      </SimpleForm>

    </Edit >


  )
};


export const LoadingRequestShow = (props) => {
  const tableRef = useRef(null);

  return (<Show {...props} aside={<Aside />} actions={null}>

    <SimpleShowLayout>

      <ReferenceField link={null} label="واحد مربوطه " source="unitId" reference="unit" >
        <TextField source="title" />
      </ReferenceField>

      <ReferenceField link={null} label="زیر واحد " source="unitProcessorId" reference="unitProcessor" >
        <TextField source="title" />
      </ReferenceField>
      <TextField source="user.name" label="ساخته شده توسط" />
      {/* <TextField source="objectId"/> */}
      <ReferenceField link={null} label="واحد گیرنده " source="unitId" reference="unit" >
        <TextField source="title" style={{ display: 'inline-grid', float: 'right', marginLeft: '10px' }} />
      </ReferenceField>


      <TextField source="descript" rows={2} label="توضیحات" />

      <TextField source="deliveryLocation" autoComplete="off" label=" محل تحویل" />

      <DateField options={{ weekday: 'long', year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }} locales="fa-IR" source="updatedAt" label=" آخرین بروزرسانی " />

      <ReactHTMLTableToExcel
        id="table-xls-button"
        className="download-table-xls-button"
        table="table-to-xls"
        filename="export-loadingRequest"
        sheet="export"
        buttonText="دریافت فایل خروجی"
      />

      <ArrayField source="products" label=" ">
        {/* <SimpleFormIterator disableRemove disableAdd disableReordering> */}
        <Datagrid id="table-to-xls" ref={tableRef}>

          <TextField source="productId.title" />

          <TextField label="تعداد موجودی" source="supply" style={{ float: 'right', marginRight: '20px', marginLeft: '10px', width: '20%' }} />
          <TextField label="تعداد درخواست" source="need" style={{ float: 'right', marginRight: '20px', marginLeft: '10px', width: '20%' }} />
          <TextField label="ارسالی" source="accepted_supply" style={{ float: 'right', marginRight: '20px', marginLeft: '10px', width: '20%' }} />


          {/* </SimpleFormIterator> */}
        </Datagrid>

      </ArrayField>

    </SimpleShowLayout>
  </Show>
  )
};
const ColoredChipField = props => {

  return (
    <ChipField
      source={props.record[props.source]}
      style={{ backgroundColor: props.record.stColor }}
      {...props}
    />
  );
};

export const LoadingRequestCreate = (props) => (
  <CreateView {...props}>
  </CreateView>
);
